import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  translateCategory,
  translateSubcategory,
} from "../services/translations";

function slugify(name) {
  return name.replace(/\s+/g, "").toLowerCase();
}

function Scenics({ language = "en" }) {
  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageErrors, setImageErrors] = useState(new Set());

  useEffect(() => {
    fetch("/compressed/scenics/index.json")
      .then((res) => res.json())
      .then((data) => {
        setSubcategories(data);
        setLoading(false);
      });
  }, []);

  // Function to get the correct file extension with fallback
  const getThumbnailUrl = (subcategory) => {
    const slug = slugify(subcategory);
    const key = `${slug}`;

    // If we've already tried PNG and it failed, use JPG
    if (imageErrors.has(key)) {
      return `/scenic_thumbnails/${slug}.jpg`;
    }

    // Try PNG first
    return `/scenic_thumbnails/${slug}.png`;
  };

  // Handle image load error - fallback to JPG
  const handleImageError = (subcategory) => {
    const slug = slugify(subcategory);
    const key = `${slug}`;
    setImageErrors((prev) => new Set([...prev, key]));
  };

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <div className='text-xl'>Loading...</div>
      </div>
    );
  }

  // must always make sure the image in the scenic_thumbnails folder is named the same as the subcategory
  // console.log("subcategories", subcategories);

  return (
    <div className='container mx-auto px-4 py-8'>
      <h1 className='text-3xl font-bold mb-8'>
        {translateCategory("scenics", language)}
      </h1>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
        {subcategories.map((sub) => (
          <Link
            key={sub}
            to={`/gallery/scenics/${slugify(sub)}`}
            className='relative aspect-[4/3] overflow-hidden group'
          >
            <div className='absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-300 z-10' />
            <div className='absolute inset-0 flex items-center justify-center z-20'>
              <h2 className='text-white text-3xl font-bold'>
                {translateSubcategory(sub, language)}
              </h2>
            </div>
            <img
              src={getThumbnailUrl(sub)}
              alt={sub}
              className='w-full h-full object-cover'
              onError={() => handleImageError(sub)}
            />
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Scenics;
